import { SidenavCount } from '../../../server/server/shared/models/sidenavCounts';

export const SidenavCounts = new Mongo.Collection<SidenavCount>(
  'sidenav-counts',
);
